import theme from '@styles/theme';
import { ThemeUIStyleObject } from 'theme-ui';
type StylesType = {
  hitArea: ThemeUIStyleObject;
  container: ThemeUIStyleObject;
  button: ThemeUIStyleObject;
  iconWrapper: ThemeUIStyleObject;
  buttonText: ThemeUIStyleObject;
  badge: ThemeUIStyleObject;
};
const styles: StylesType = {
  hitArea: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: ['80px', '84px', '88px', '96px'],
    cursor: 'pointer',
    zIndex: theme.zIndex.documentUp + 1,
    display: 'flex',
    alignItems: 'flex-end',
    padding: ['8px 4px', '12px 8px', '24px 24px', '28px 28px', '32px 32px', '36px 40px'],
    '@media (min-width: 768px)': {
      '&:hover': {
        '& .dashed-border': {
          opacity: 1
        },
        '& .icon-wrapper': {
          transform: 'scale(0.65)'
        },
        '& .cart-button-text': {
          opacity: 1,
          transform: 'translateX(-5px)'
        }
      }
    }
  },
  container: {
    position: 'relative',
    display: 'inline-flex'
  },
  button: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    gap: ['6px', '8px', '10px'],
    height: ['40px', '42px', '44px', '48px'],
    backgroundColor: 'transparent',
    border: '1px dashed transparent',
    borderRadius: '100px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: theme.rawColors.neutralWhite,
    padding: ['0', '0', '10px 16px 10px 12px'],
    '& > svg.dashed-border': {
      pointerEvents: 'none',
      opacity: 0,
      transition: 'opacity 0.3s ease',
      '& rect': {
        fill: 'none',
        stroke: theme.rawColors.neutralWhite,
        strokeWidth: 1,
        strokeDasharray: '4 5'
      }
    }
  },
  iconWrapper: {
    fill: theme.rawColors.neutralWhite,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'transform 0.3s ease',
    width: '40px',
    height: '40px',
    svg: {
      width: ['24px', '28px', '32px', '32px', '36px', '36px'],
      height: ['24px', '28px', '32px', '32px', '36px', '36px']
    }
  },
  buttonText: {
    marginTop: '-2px',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: ['12px', '14px', '16px'],
    color: theme.rawColors.neutralWhite,
    whiteSpace: 'nowrap',
    opacity: 0,
    transition: 'all 0.3s ease',
    transform: 'translateX(-8px)'
  },
  badge: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    minWidth: '18px',
    height: '18px',
    padding: '0 5px',
    borderRadius: '50%',
    backgroundColor: theme.rawColors.accent700,
    color: theme.rawColors.neutralWhite,
    fontSize: '11px',
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1
  }
};
export default styles;